module.exports = __webpack_public_path__ + "img/2_way.0cdbe74b.jpg";